import { render, staticRenderFns } from "./AxWorkspaceIcon.vue?vue&type=template&id=675cc656&scoped=true&"
import script from "./AxWorkspaceIcon.vue?vue&type=script&lang=ts&"
export * from "./AxWorkspaceIcon.vue?vue&type=script&lang=ts&"
import style0 from "./AxWorkspaceIcon.vue?vue&type=style&index=0&id=675cc656&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675cc656",
  null
  
)

export default component.exports